import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year4/Summer/Money/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Money',
  field: 'Measurement',
  weeks: [3, 4],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/Money/1WriteMoneyUsingDecimals" */ './1WriteMoneyUsingDecimals'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/Money/2ConvertBetweenPoundsAndPence" */ './2ConvertBetweenPoundsAndPence'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/Money/3CompareAmountsOfMoney" */ './3CompareAmountsOfMoney'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/Money/4EstimateWithMoney" */ './4EstimateWithMoney'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/Money/5CalculateWithMoney" */ './5CalculateWithMoney'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/Money/6SolveProblemsWithMoney" */ './6SolveProblemsWithMoney'
        )
    })
  ]
});
export default Block;
